import React, { Component } from 'react';
import { connect } from 'react-redux';
import { change } from 'redux-form';
import {
    GoogleMap,
    Marker,
    Polyline
} from "@react-google-maps/api";

import { googleMapLoader } from '../../../helpers/googleMapLoader';

import originMarker from '../../../../public/Icons/MapMarker/originMarker.png';
import destinationMarker from '../../../../public/Icons/MapMarker/destinationMarker.png';
import stopMarker from '../../../../public/Icons/MapMarker/stopMarker.png';

const refs = {};
class ShowMap extends Component {
    static defaultProps = {
        zoom: 4,
        height: '400px',
        width: '100%',
        center: { lat: 37.0902, lng: -95.7129 }
    };

    constructor(props) {
        super(props);
        this.state = {
            googleMapsApiLoaded: false,
        }
    }

    async componentDidMount() {
        await googleMapLoader();
        this.setState({ googleMapsApiLoaded: true });
    }

    onPolygonLoad = (map) => {
        const { mapMarkerPoints, sw_lat, sw_lng, ne_lat, ne_lng } = this.props;
        let bounds, new_sw, new_ne, setBounds;
        bounds = new google.maps.LatLngBounds();
        if (map && mapMarkerPoints?.length > 0) {
            mapMarkerPoints.forEach((i) => {
                bounds.extend(new google.maps.LatLng(parseFloat(i.lat), parseFloat(i.lng)));
            });
            setBounds = true;
        }
        if (sw_lat && sw_lng && ne_lat && ne_lng) {
            new_sw = new google.maps.LatLng(sw_lat, sw_lng);
            new_ne = new google.maps.LatLng(ne_lat, ne_lng);
            bounds.extend(new_sw);
            bounds.extend(new_ne);
            setBounds = true;
        }
        if (map && setBounds) map.fitBounds(bounds);
        refs.map = map;
    }

    render() {
        const { mapMarkerPoints, mapRouteDirections, zoom, height, width, center } = this.props;
        const { googleMapsApiLoaded } = this.state;
        let mapStyles = [
            {
                featureType: "poi",
                elementType: "geometry",
                stylers: [
                    {
                        color: "#eeeeee",
                    },
                ],
            },
            {
                featureType: "poi",
                elementType: "labels.text",
                stylers: [
                    {
                        visibility: "off",
                    },
                ],
            },
            {
                featureType: "water",
                elementType: "labels.text.fill",
                stylers: [
                    {
                        color: "#9e9e9e",
                    },
                ],
            },
        ];


        return (
            googleMapsApiLoaded ?
                <div>
                    <GoogleMap
                        ref={(map) => this.map = map}
                        zoom={zoom}
                        center={center}
                        mapContainerStyle={{ height, width }}
                        onLoad={this.onPolygonLoad}
                        onBoundsChanged={this.onPolygonLoad(refs.map)}
                        options={{
                            styles: mapStyles,
                            disableDefaultUI: true,
                            zoomControl: true,
                            zoomControlOptions: {
                                position: google.maps.ControlPosition.LEFT_BOTTOM
                            }
                        }}
                    >
                        {
                            mapRouteDirections && mapMarkerPoints && mapMarkerPoints.length > 0 && mapMarkerPoints.map((position, index) => (
                                <Marker
                                    key={index}
                                    position={position}
                                    icon={index === 0 ? originMarker : (index === mapMarkerPoints.length - 1 ? destinationMarker : stopMarker)}
                                />
                            ))
                        }
                        {
                            mapRouteDirections && <Polyline
                                path={mapRouteDirections}
                                options={{
                                    geodesic: true
                                }}
                            />
                        }
                    </GoogleMap>
                </div>
                : <></>
        )
    }
}

const mapState = state => ({});

const mapDispatch = {
    change
};

export default connect(mapState, mapDispatch)(ShowMap);